// extracted by mini-css-extract-plugin
module.exports = {"block":"Layout1_block__2DMLR","blockMedia":"Layout1_blockMedia__1IB87","assets":"Layout1_assets__35cgk"};